import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { VoiceDictationComponent } from '../../../components/voice-dictation/voice-dictation.component';

@Component({
  selector: 'fastr-ui-ai-chat-custom-value',
  templateUrl: './ai-chat-custom-value.component.html',
  styleUrls: ['./ai-chat-custom-value.component.scss'],
})
export class AiChatCustomValueComponent implements OnDestroy {
  @Input() value = '';
  @Input() placeholder = 'Type your own';
  @Input() disabled = false;
  @Input() showEditIcon = true;
  @Input() showVoiceIcon = true;
  @Input() showSubmitButton = false;

  @Output() valueChange = new EventEmitter<string>();
  @Output() submitted = new EventEmitter<void>();

  @ViewChild(VoiceDictationComponent) private voiceDictation?: VoiceDictationComponent;

  ngOnDestroy(): void {
    this.stop();
  }

  updateValue(event: Event): void {
    this.valueChange.emit((event.target as HTMLInputElement).value);
  }

  submit(): void {
    this.submitted.emit();
  }

  appendTranscript(text: string): void {
    this.valueChange.emit(this.value ? `${this.value} ${text}` : text);
  }

  stop(): void {
    this.voiceDictation?.stop();
  }
}
